<template>
  <b-overlay
    variant="white"
    :show="showLoading"
    spinner-variant="primary"
    blur="0"
    opacity=".75"
    rounded="sm"
  >
    <b-card>
      <!-- form -->
      <validation-observer ref="hardwareCreate">
        <b-form>
          <b-row>
            <b-col md="12">
              <div class="section-block mb-4">
                <div class="section-block__title">
                  <feather-icon
                    icon="ListIcon"
                    width="24"
                    height="24"
                  />
                  <h2>Hardware specifications</h2>
                </div>
                <b-form-group
                  label="Name*"
                  label-class="label-class"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    vid="name"
                    rules="required|max:255"
                  >
                    <b-form-input
                      v-model="form.name"
                      autocomplete="off"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-row
                  class="neighbouring-form-container"
                >
                  <b-col
                    class="neighbouring-form-group"
                  >
                    <b-form-group
                      label="Model*"
                      label-class="label-class"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Model"
                        vid="model_id"
                        rules="required"
                      >
                        <v-select
                          v-model="form.model_id"
                          :options="modelList"
                          :reduce="model => model.id"
                          label="name"
                          class="selector-height"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    class="neighbouring-form-group"
                  >
                    <b-form-group
                      label="Serial number*"
                      label-class="label-class"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Serial number"
                        vid="serial_number"
                        rules="required|alpha-num|min:11|max:14"
                      >
                        <b-form-row>
                          <b-col>
                            <b-form-input
                              v-model="form.serial_number"
                              autocomplete="off"
                              placeholder="Serial number"
                              :state="errors.length > 0 ? false:null"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-col>
                        </b-form-row>

                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-form-row>
                <b-form-group
                  label="Warranty expiry at"
                  label-class="label-class"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Warranty expiry at"
                    vid="warranty_expiry_at"
                  >
                    <b-form-datepicker
                      id="warranty_expiry_at"
                      v-model="form.warranty_expiry_at"
                      :min="minDate"
                      locale="en-GB"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      class="mb-1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Comment"
                  label-class="label-class"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Comment"
                    vid="comment"
                    rules="max:255"
                  >
                    <b-form-input
                      v-model="form.comment"
                      autocomplete="off"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Comment"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div
                v-if="!isClient"
                class="section-block mb-4"
              >
                <div class="section-block__title">
                  <feather-icon
                    icon="UsersIcon"
                    width="24"
                    height="24"
                  />
                  <h2>Customer details</h2>
                </div>
                <p
                  class="text-muted mt-0 mb-2"
                >
                  You can assign your hardware to a company now, or you can leave this blank and assign later.
                </p>

                <!-- <div
                class="mb-1"
              >
                <multiselect
                  v-model="selected"
                  :options="options"
                  multiple
                  placeholder="Select owner’s type"
                  class="multiselect"
                  :searchable="false"
                  @select="onSelect"
                />
              </div> -->

                <b-form-group
                  v-if="!company"
                  label=""
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Company"
                    vid="company_id"
                  >
                    <v-select
                      v-model="company"
                      v-b-tooltip.hover.left
                      :options="companies"
                      class="owner-select"
                      placeholder="Select company name"
                      label="name"
                      @search="onSearch($event, 'company')"
                      @input="onSelectCompany($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div
                  v-else
                  class="mb-2"
                >
                  <b-button
                    variant="primary"
                    class="transparent-button"
                    @click="onReselectCompany"
                  >
                    Clear selection
                  </b-button>
                </div>
                <div v-if="company || site">
                  <b-form-group
                    v-if="$can('view', SELECT_MASTER_DISTRIBUTOR) && masterDistributor"
                    label="Master Distributor"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Master Distributor"
                      vid="master_distributor_id"
                    >
                      <v-select
                        v-model="masterDistributor"
                        v-b-tooltip.hover.left
                        :disabled="site"
                        :title="site ? 'This field can’t be edited as it’s linked to the selected site.' : ''"
                        :options="masterDistributors"
                        placeholder="Enter name"
                        label="name"
                        :class="selected[0] !== 'Master Distributor' ? 'disabled-clear owner-select' : 'owner-select'"
                        @search="onSearch($event, 'master-distributor')"
                        @input="onSelectedUser($event, 'master-distributor')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-if="$can('view', SELECT_DISTRIBUTOR) && (distributor || masterDistributor)"
                    label="Distributor"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Distributor"
                      vid="distributor_id"
                    >
                      <v-select
                        v-model="distributor"
                        v-b-tooltip.hover.left
                        :disabled="site"
                        :title="site ? 'This field can’t be edited as it’s linked to the selected site.' : ''"
                        :options="distributors"
                        placeholder="Enter name"
                        label="name"
                        :class="selected[0] !== 'Distributor' ? 'disabled-clear owner-select' : 'owner-select'"
                        @search="onSearch($event, 'distributor')"
                        @input="onSelectedUser($event, 'distributor')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-if="$can('view', SELECT_RESELLER) && (reseller || distributor)"
                    label="Reseller"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Reseller"
                      vid="reseller_id"
                    >
                      <v-select
                        v-model="reseller"
                        v-b-tooltip.hover.left
                        :disabled="site"
                        :title="site ? 'This field can’t be edited as it’s linked to the selected site.' : ''"
                        :options="resellers"
                        placeholder="Enter name"
                        label="name"
                        :class="selected[0] !== 'Reseller' ? 'disabled-clear owner-select' : 'owner-select'"
                        @search="onSearch($event, 'reseller')"
                        @input="onSelectedUser($event, 'reseller')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group
                    v-if="$can('view', SELECT_CLIENT) && (client || reseller)"
                    label="Client"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Client"
                      vid="client_id"
                    >
                      <v-select
                        v-model="client"
                        v-b-tooltip.hover.left
                        :disabled="site"
                        :title="site ? 'This field can’t be edited as it’s linked to the selected site.' : ''"
                        :options="clients"
                        placeholder="Enter name"
                        label="name"
                        :class="selected[0] !== 'Client' ? 'disabled-clear owner-select' : 'owner-select'"
                        @search="onSearch($event, 'client')"
                        @input="onSelectedUser($event, 'client')"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>
              </div>
              <div class="section-block mb-4">
                <div class="section-block__title">
                  <feather-icon
                    icon="MapIcon"
                    width="24"
                    height="24"
                  />
                  <h2>Site</h2>
                </div>
                <p
                  class="text-muted mt-0 mb-2"
                >
                  You can assign your hardware to a site now, or you can leave this blank and assign later.
                </p>

                <b-form-group
                  label=""
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Site"
                    vid="site_id"
                  >
                    <v-select
                      v-model="site"
                      :options="siteList"
                      placeholder="Enter site name"
                      class="selector-height"
                      label="name"
                      @search="onSearch($event, 'site')"
                      @input="onSelectedUser($event, 'site')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
            </b-col>
            <!-- submit button -->
            <!-- submit button -->
            <b-col
              cols="12"
              class="text-right buttons-container__left"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="button"
                ok-variant="secondary"
                @click.prevent="goBack"
              >
                Cancel
              </b-button>
              <b-button-request
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                text="Submit"
                :disabled="isSavingActionInProgress"
                :request="validationForm"
              />
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormDatepicker, BCard, BFormRow,
  VBTooltip,
  BOverlay,
} from 'bootstrap-vue'
import {
  required, max, alphaNum, numeric, min,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import rolesPermission from '@/libs/acl_roles/rolesPermission'
import { mapActions, mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { debounce } from '@/utils/utils'
import BButtonRequest from '@/components/BButtonRequest.vue'
import axiosIns from '../axios-resolver'
// import Multiselect from 'vue-multiselect'

export default {
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BFormRow,
    BRow,
    BCol,
    BButton,
    BFormDatepicker,
    BCard,
    vSelect,
    BButtonRequest,
    BOverlay,
  },
  data() {
    return {
      form: {
        name: '',
        model_id: '',
        serial_number: '',
        warranty_expiry_at: null,
        comment: null,
      },
      timeoutUpdate: null,
      company: null,
      siteIdFromQuery: null,
      showLoading: true,

      isFormSubmitting: false,
      minDate: '',
      options: ['Client', 'Reseller', 'Distributor', 'Master Distributor'],
      modelList: [],
      required,
      min,
      max,
      alphaNum,
      numeric,
      selected: [],
      SELECT_MASTER_DISTRIBUTOR: rolesPermission.SELECT_MASTER_DISTRIBUTOR,
      SELECT_DISTRIBUTOR: rolesPermission.SELECT_DISTRIBUTOR,
      SELECT_RESELLER: rolesPermission.SELECT_RESELLER,
      SELECT_CLIENT: rolesPermission.SELECT_CLIENT,
      SELECT_SITE: rolesPermission.SELECT_SITE,
      HARDWARE_SELECT_ANY_WARRANTY_EXPIRY_AT: rolesPermission.HARDWARE_SELECT_ANY_WARRANTY_EXPIRY_AT,
    }
  },
  computed: {
    ...mapFields('user', [
      'masterDistributor',
      'distributor',
      'reseller',
      'client',
      'site',
      'masterDistributorList',
      'clients',
      'resellers',
      'distributors',
      'masterDistributors',
      'distributorList',
      'resellerList',
      'clientList',
      'siteList',
    ]),
    ...mapState('companyManagement', {
      companies: 'items',
    }),
    isClient() {
      const { roles } = JSON.parse(localStorage.getItem('userData'))
      return roles.includes('client')
    },
  },
  watch: {
    distributor(val) {
      clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = setTimeout(() => {
        this.handleSiteFilter(val)
      }, 500)
      if (!val) {
        this.selected = ['Master Distributor']
        this.client = null
        this.reseller = null
      } else if (!this.reseller && !this.client) {
        this.selected = ['Distributor']
      }
    },
    reseller(val) {
      clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = setTimeout(() => {
        this.handleSiteFilter(val)
      }, 500)
      if (!val) {
        this.selected = ['Distributor']
        this.client = null
      } else if (!this.client) {
        this.selected = ['Reseller']
      }
    },
    masterDistributor(val) {
      clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = setTimeout(() => {
        this.handleSiteFilter(val)
      }, 500)
      if (!val) {
        this.selected = ['Master Distributor']
        this.distributor = null
        this.reseller = null
        this.client = null
      } else if (!this.reseller && !this.distributor && !this.client) {
        this.selected = ['Master Distributor']
      }
    },
    client(val) {
      clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = setTimeout(() => {
        this.handleSiteFilter(val)
      }, 500)
      if (!val) {
        this.selected = ['Reseller']
      } else {
        this.selected = ['Client']
      }
    },
  },
  async created() {
    if (!this.$route.query.siteId) {
      this.showLoading = false
    }
    await this.fetchModelList()
    await this.fetchCompanies({ query: '' })
    await Promise.all([
      this.fetchCompaniesList({ query: '', company_type: 'client' }),
      this.fetchCompaniesList({ query: '', company_type: 'reseller' }),
      this.fetchCompaniesList({ query: '', company_type: 'distributor' }),
      this.fetchCompaniesList({ query: '', company_type: 'master-distributor' }),
      this.search({ query: '', company_type: 'site' }, this.fetchSiteList),
    ]).then(async () => {
      if (this.$route.query.siteId) {
        this.siteIdFromQuery = Number(this.$route.query.siteId)
        await this.setSiteName(this.$route.query.siteId)
        const foundedSite = this.siteList.find(item => item.id === this.siteIdFromQuery)
        if (foundedSite) {
          this.site = foundedSite
          await this.onSelectedUser(foundedSite, 'site')
        }
        this.showLoading = false
      }
    })

    if (this.$can('view', this.SELECT_MASTER_DISTRIBUTOR)) {
      this.options = ['Client', 'Reseller', 'Distributor', 'Master Distributor']
    } else if (this.$can('view', this.SELECT_DISTRIBUTOR)) {
      this.options = ['Client', 'Reseller', 'Distributor']
    } else if (this.$can('view', this.SELECT_RESELLER)) {
      this.options = ['Client', 'Reseller']
    } else if (this.$can('view', this.SELECT_CLIENT)) {
      this.options = ['Client']
    } else {
      this.options = []
    }
  },
  mounted() {
    if (!this.$can('view', this.HARDWARE_SELECT_ANY_WARRANTY_EXPIRY_AT)) {
      this.minDate = new Date()
    }
  },
  destroyed() {
    document.querySelector('.content-header-title__extra-info').innerHTML = ''
  },
  methods: {
    ...mapActions('user', [
      'fetchCompaniesList',
      'fetchHardwareSelectedCompany',
    ]),
    ...mapActions('hardware', [
      'createItem',
    ]),
    ...mapActions('companyManagement', {
      fetchCompanies: 'getItems',
    }),
    ...mapMutations({
      resetUserState: 'user/RESET_STATE',
    }),
    async setSiteName(id) {
      try {
        if (id) {
          const pageTitle = document.querySelector('.content-header-title__extra-info')
          const { data: { data } } = await axiosIns.get(`/site/${id}/show`)

          const link = document.createElement('a')
          link.href = `/site/${id}/hardware/index`
          link.innerHTML = `(${data.name})`

          pageTitle.innerHTML = ''
          pageTitle.appendChild(link)
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    handleSiteFilter() {
      let id = null
      if (this.client) {
        id = this.client.id
      } else if (this.reseller) {
        id = this.reseller.id
      } else if (this.distributor) {
        id = this.distributor.id
      } else if (this.masterDistributor) {
        id = this.masterDistributor.id
      }
      this.fetchSiteList({
        parent_company_id: id,
      })
    },
    onReselectCompany() {
      this.resetUserState()
      this.company = null
      this.masterDistributor = null
      this.distributor = null
      this.reseller = null
      this.client = null
      this.site = null
      this.selected = []
    },
    onSelect(option) {
      console.log('option :>> ', option)
      if (option === 'Client') {
        this.selected = ['Client']
      }

      if (option === 'Reseller') {
        this.selected = ['Reseller']
        this.client = null
      }

      if (option === 'Distributor') {
        this.selected = ['Distributor']
        this.reseller = null
        this.client = null
      }

      if (option === 'Master Distributor') {
        this.selected = ['Master Distributor']
        this.distributor = null
        this.reseller = null
        this.client = null
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    onSearch(query, type) {
      if (type === 'company') {
        // search=name:Ne&searchFields=name&searchJoin=and

        if (!query) {
          this.fetchCompanies({ search: '', searchFields: '', searchJoin: '' })
          return
        }

        this.fetchCompanies({
          search: `name:${query}`,
          searchFields: 'name',
          searchJoin: 'and',
        })
      }
      if (!query) {
        return
      }

      let payload = {
        query,
        company_type: type,
      }
      if (type === 'master-distributor') {
        this.reseller = null
        this.client = null
        this.distributor = null
        this.search(payload, this.fetchCompaniesList)
      }

      if (type === 'distributor') {
        this.reseller = null
        this.client = null
        this.search(payload, this.fetchCompaniesList)
      }

      if (type === 'reseller') {
        this.client = null
        if (this.distributor) {
          payload = {
            ...payload,
            ...{ distributor_id: this.distributor.id },
          }
        }

        this.search(payload, this.fetchCompaniesList)
      }

      if (type === 'client') {
        if (this.distributor) {
          payload = {
            ...payload,
            ...{ distributor_id: this.distributor.id },
          }
        }

        if (this.reseller) {
          payload = {
            ...payload,
            ...{ reseller_id: this.reseller.id },
          }
        }

        this.search(payload, this.fetchCompaniesList)
      }

      if (type === 'site') {
        if (this.distributor) {
          payload = {
            ...payload,
            ...{ distributor_id: this.distributor.id },
          }
        }

        if (this.reseller) {
          payload = {
            ...payload,
            ...{ reseller_id: this.reseller.id },
          }
        }

        if (this.client) {
          payload = {
            ...payload,
            ...{ client_id: this.client.id },
          }
        }

        this.search(payload, this.fetchSiteList)
      }
    },
    search: debounce((payload, fetchAction) => {
      fetchAction({ ...payload })
    }, 350),
    async onSelectCompany(option) {
      console.log('option :>> ', option)
      const selectedUser = {
        id: option.id,
        name: option.name,
      }
      this.fetchHardwareSelectedCompany({
        company_id: option.id,
      })
      switch (option.type.name) {
        case 'Master Distributor':
          this.masterDistributor = selectedUser
          this.distributor = null
          this.reseller = null
          this.client = null
          this.site = null
          break
        case 'Distributor':
          this.distributor = selectedUser
          this.reseller = null
          this.client = null
          this.site = null
          break
        case 'Reseller':
          this.reseller = selectedUser
          this.client = null
          this.site = null
          break
        case 'Client':
          this.client = selectedUser
          this.site = null
          break
        default:
          this.masterDistributor = null
          this.distributor = null
          this.reseller = null
          this.client = null
          this.site = null
          break
      }
    },
    async onSelectedUser(option, type) {
      let payload = {}
      payload.company_id = option.id
      if (type === 'master-distributor') {
        this.distributor = null
        this.reseller = null
        this.client = null
        this.distributorList = []
        this.resellerList = []
        this.clientList = []
        this.fetchHardwareSelectedCompany(payload)
      }

      if (type === 'distributor') {
        this.reseller = null
        this.client = null
        this.resellerList = []
        this.clientList = []
        this.selected = ['Distributor']
        if (!option) {
          return
        }
        this.fetchHardwareSelectedCompany(payload)
      }

      if (type === 'reseller') {
        this.client = null
        this.selected = ['Reseller']

        this.clientList = []
        if (!option) {
          return
        }
        this.fetchHardwareSelectedCompany(payload)
      }

      if (type === 'client') {
        if (!option) {
          return
        }
        this.selected = ['Client']
        if (!this.reseller && this.distributor) {
          payload = {
            ...payload,
            ...{ distributor_id: this.distributor.id },
          }
        }

        payload = {
          ...payload,
        }

        this.fetchHardwareSelectedCompany(payload)
      }

      if (type === 'site') {
        if (!option) {
          return
        }
        payload = {
          ...payload,
          ...{ site_id: option.id },
        }
        delete payload.company_id
        this.fetchHardwareSelectedCompany(payload)
      }
    },
    async fetchModelList() {
      try {
        const { data } = await this.$http.get('/hardware/model/list')

        this.modelList = data.data
      } catch (error) {
        console.log('error :>> ', error)
      }
    },
    async fetchSiteList({ ...payload }) {
      try {
        const { data } = await this.$http.get('/site/list', { params: { ...payload } })

        this.siteList = data.data

        if (this.site) {
          const site = this.siteList.find(item => item.id === this.site.id)
          if (!site) {
            this.site = null
          }
        }
      } catch (error) {
        console.log('error :>> ', error)
      }
    },
    async validationForm() {
      const valid = await this.$refs.hardwareCreate.validate()

      if (valid) {
        try {
          let payload = {
            ...this.form,
          }

          if (this.$can('view', this.SELECT_MASTER_DISTRIBUTOR)) {
            payload = {
              ...payload,
              ...{ master_distributor_id: this.masterDistributor ? this.masterDistributor.id : null },
            }
          }

          if (this.$can('view', this.SELECT_DISTRIBUTOR)) {
            payload = {
              ...payload,
              ...{ distributor_id: this.distributor ? this.distributor.id : null },
            }
          }

          if (this.$can('view', this.SELECT_RESELLER)) {
            payload = {
              ...payload,
              ...{ reseller_id: this.reseller ? this.reseller.id : null },
            }
          }

          if (this.$can('view', this.SELECT_CLIENT)) {
            payload = {
              ...payload,
              ...{ client_id: this.client ? this.client.id : null },
            }
          }
          payload = {
            ...payload,
            ...{ site_id: this.site ? this.site.id : null },
          }

          this.isFormSubmitting = true
          await this.createItem(payload)

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success!',
              icon: 'BellIcon',
              variant: 'success',
            },
          })

          if (this.$route.query.siteId) {
            this.$router.push({
              name: 'site-summary',
              params: { id: this.$route.query.siteId },
              query: { tab: 0 },
            })
          } else {
            this.$router.push({ name: 'hardware-list' })
          }
        } catch (error) {
          const { status } = error.response
          const errorMessage = error.response?.data?.message

          if (!status) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Server error',
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
          }

          if (errorMessage) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Cannot create hardware',
                content: errorMessage,
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
          }

          if (status === 422) {
            const { fields } = error.response.data

            this.$refs.hardwareCreate.setErrors(fields)
          }
        } finally {
          this.isFormSubmitting = false
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.resetUserState()

    next()
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

</style>
